/* generated using openapi-typescript-codegen — list/mutate methods hand-extended */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {
    AdEntityBatchUpdateRequest,
    AdEntityBatchUpdateResponse,
    AdEntityListResponse,
} from '../models/AdEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FacebookAdsService {
    /**
     * Connect a Facebook Ads account
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully connected a Facebook Ads account
     * @throws ApiError
     */
    public static postFacebookAdsConnect(
        workspaceId: string,
        requestBody: {
            name: string;
            code: string;
            ad_account_id: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/facebook_ads/connect',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Disconnect a Facebook Ads account
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully disconnected a Facebook Ads account
     * @throws ApiError
     */
    public static postFacebookAdsDisconnect(
        workspaceId: string,
        requestBody: {
            ad_account_id: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/facebook_ads/disconnect',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List connected Facebook Ads accounts
     * @param workspaceId Workspace ID is required in every request
     * @returns any List connected Facebook Ads accounts
     * @throws ApiError
     */
    public static getFacebookAdsConnected(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/facebook_ads/connected',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List Facebook Ads campaigns
     */
    public static getFacebookAdsCampaigns(
        workspaceId: string,
        adAccountId: string,
    ): CancelablePromise<AdEntityListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/facebook_ads/campaigns',
            query: {
                'workspace_id': workspaceId,
                'ad_account_id': adAccountId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List Facebook Ads ad sets
     */
    public static getFacebookAdsAdsets(
        workspaceId: string,
        adAccountId: string,
        campaignId?: string,
    ): CancelablePromise<AdEntityListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/facebook_ads/adsets',
            query: {
                'workspace_id': workspaceId,
                'ad_account_id': adAccountId,
                'campaign_id': campaignId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List Facebook Ads ads
     */
    public static getFacebookAdsAds(
        workspaceId: string,
        adAccountId: string,
        adsetId?: string,
    ): CancelablePromise<AdEntityListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/facebook_ads/ads',
            query: {
                'workspace_id': workspaceId,
                'ad_account_id': adAccountId,
                'adset_id': adsetId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Batch update Facebook Ads entities (status / daily_budget)
     */
    public static postFacebookAdsEntitiesBatchUpdate(
        workspaceId: string,
        requestBody: AdEntityBatchUpdateRequest,
    ): CancelablePromise<AdEntityBatchUpdateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/facebook_ads/entities/batch_update',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
    }
}
